var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ListingTableFilter", {
    attrs: {
      filter: _vm.filter,
      valuesHumanized: _vm.appliedFilterLabels,
      filterConfig: _vm.filterConfig
    },
    on: {
      updateFilter: _vm.updateFilter,
      updateVisibility: _vm.updateVisibility,
      removeFilter: _vm.removeFilter
    },
    scopedSlots: _vm._u([
      {
        key: "filterDropdownContent",
        fn: function() {
          return _vm._l(_vm.filter.options, function(option) {
            return _c(
              "CompassDropdownOption",
              _vm._b(
                { key: option.id, attrs: { value: option.id } },
                "CompassDropdownOption",
                option,
                false
              )
            )
          })
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }